angular.module('hal-common').directive('halGeneratorWords', function () {
  return {
    restrict: 'E',
    templateUrl: '/templates/hal-common/directives/generator-words.html',
  };
});
